<template lang="pug">
footer.bg-white
  .container.grid-md.p-relative
    .columns.py-1(:class="{collapsed: collapsed}")
      .column.col-auto
        router-link(:to="{ name: 'app.about' }") Sobre o sistema
      .column
        span
          | Desenvolvido por
          a(href='http://paliari.com.br' target='_blank') &nbsp;Paliari Engenharia de Software&nbsp;
          | © {{new Date().getFullYear()}}&nbsp;
        code
          small (v{{version}})
</template>

<script>
  import { version } from '../../package'

  export default {
    props: { collapsed: Boolean },
    data() {
      return {
        version
      }
    }
  }
</script>

<style lang="stylus" scoped>
  footer
    text-align right
    padding 5px
    color #999
    font-size .6rem

</style>
